import React from 'react';
import { Grid } from '@material-ui/core';
import { PveRunList } from './PveRunList';
import { PveNav } from '../PveNav';

/** Every finished dungeon / raid run. */
export const PveRunsPage: React.FC = () => {
  return (
    <Grid container spacing={2} className="content-container">
      <Grid item xs={12}>
        <PveNav />
        <PveRunList />
      </Grid>
    </Grid>
  );
}
